import { Component, OnInit, Input, OnDestroy } from '@angular/core';

import { DataService, HelperService, HTTPService } from 'app/services';

import { Subscription } from 'rxjs';

@Component({
  selector: 'app-troubleshoot-code',
  templateUrl: './troubleshoot-code.component.html',
  styleUrls: ['./troubleshoot-code.component.scss'],
})
export class TroubleshootCodeComponent implements OnInit, OnDestroy {
  @Input() motorVehicle: any = {};
  @Input() motorVehicleId: string = '';
  @Input() query: string = '';
  @Input() isServiceLookup: boolean = false;

  isLoading: boolean = false;
  documentUrls: any[] = [];
  pdfDocument: string = '';
  imageIndex: number = 0;
  troubleShootCode: any[] = [];
  dataListener: Subscription;
  selectedCode: any = {};
  options: any = {
    EN: '',
    CO: '',
    SM: '',
  };
  config = {
    btnClass: 'default',
    zoomFactor: 0.1,
    containerBackgroundColor: '#ccc',
    wheelZoom: true,
    allowFullscreen: true,
    allowKeyboardNavigation: true,
    btnIcons: {
      zoomIn: 'fal fa-search-plus',
      zoomOut: 'fal fa-search-minus',
      next: 'fas fa-caret-right',
      prev: 'fas fa-caret-left',
      fullscreen: 'fal fa-expand',
    },
    btnShow: {
      zoomIn: true,
      zoomOut: true,
      next: true,
      prev: true,
    },
  };
  contentType: string = '';

  constructor(private httpService: HTTPService, private helperService: HelperService, private dataService: DataService) {}

  ngOnInit() {
    if (this.motorVehicleId) {
      const { CountryID, EngineID, SubModelID } = this.motorVehicle;

      this.options = {
        EN: EngineID,
        CO: CountryID,
        SM: SubModelID,
      };
      this.setDataService();
      this.searchTroubleshootCode();
    }
  }

  ngOnDestroy() {
    if (this.dataListener) {
      this.dataListener.unsubscribe();
    }
  }

  setDataService() {
    this.dataListener = this.dataService.getData().subscribe(({ data }) => {
      if (data.key === 'motor-on-search') {
        this.query = data.data.query;
        this.searchTroubleshootCode();
      }
    });
  }

  searchTroubleshootCode() {
    if (!this.query) return;

    const data = {
      ...this.options,
      vehicleId: this.motorVehicleId,
      query: this.query,
    };
    this.isLoading = true;
    this.httpService
      .getTroubleshootCodeBySearch(data)
      .then(
        ({ data }) => {
          if (data) {
            this.troubleShootCode = data;
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isLoading = false;
      });
  }

  getTroubleshootDetails(applicationId: string) {
    this.isLoading = true;
    const data = {
      applicationId,
      ...this.options,
      query: this.query,
      vehicleId: this.motorVehicleId,
    };
    this.imageIndex = 0;
    this.httpService
      .getTroubleshootDetails(data)
      .then(
        ({ code }) => {
          if (code) {
            this.selectedCode = code;
            const { images } = code;

            if (images && images.length === 1 && images[0].format === 'application/pdf') {
              this.contentType = 'pdf';

              const [image] = images;
              const binary = atob(image.image.replace(/\s/g, ''));
              const buffer = new ArrayBuffer(binary.length);
              const view = new Uint8Array(buffer);

              for (let i = 0; i < binary.length; i++) {
                view[i] = binary.charCodeAt(i);
              }

              this.pdfDocument = `${URL.createObjectURL(new Blob([view], { type: 'application/pdf' }))}##view=FitW`;

              setTimeout(() => {
                document.getElementById('trouble-code-pdf').setAttribute('data', this.pdfDocument);
              }, 1000);
            } else {
              this.documentUrls = images.map(({ image }) => image);
              this.contentType = 'image';
            }
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => (this.isLoading = false));
  }
}
